import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { getAppImage } from 'helpers';
import { APP_IMAGES } from 'constants/index';
import { Index } from 'Links';

interface IProps {
  type?: keyof IErrors;
}

interface IError {
  title: string;
  subtitle: string;
}

interface IErrors {
  'not-found': IError;
  'no-client': IError;
  'no-user': IError;
  general: IError;
}

const useStyles = makeStyles(theme => ({
  container: {
    margin: theme.custom.bodyMargin,
    maxWidth: theme.breakpoints.values.md,
  },
  wrapper: {
    boxShadow: theme.custom.shadows.depth1,
    borderRadius: theme.spacing(5),
  },
  image: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
}));

const errors: IErrors = {
  'not-found': {
    title: 'errors:notFound',
    subtitle: 'errors:notFoundSubheader',
  },
  'no-client': {
    title: 'errors:noClient',
    subtitle: 'errors:notFoundSubheader',
  },
  'no-user': {
    title: 'errors:noUser',
    subtitle: 'errors:notFoundSubheader',
  },
  general: {
    title: 'errors:unknown',
    subtitle: 'errors:notFoundSubheader',
  },
};

const ErrorPage: FC<IProps> = ({ type }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Grid container direction="column" justify="center" className={classes.container} spacing={3}>
      <Grid item>
        <img {...getAppImage(APP_IMAGES.Logo)} />
      </Grid>
      <Grid item>
        <div className={classes.wrapper}>
          <img className={classes.image} {...getAppImage(APP_IMAGES.Invalid)} />
          <Grid container direction="column" alignItems="center" spacing={5}>
            <Grid item xs={12}>
              <Typography display="inline" variant="h2">
                {t(errors[type].title)}
              </Typography>
              <Typography display="inline" variant="h3">
                {t(errors[type].subtitle)}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Button size="large" variant="contained" color="primary" component={Index}>
                {t('errors:button')}
              </Button>
            </Grid>
          </Grid>
        </div>
      </Grid>
    </Grid>
  );
};

ErrorPage.defaultProps = {
  type: 'general',
};

export default ErrorPage;
